import React, { useState, useEffect } from "react";
import { EditBlock, EditBlockOption } from "../EditBlock";
import { Col, Row, Input, Button } from "antd";
import style from "./EditTianKong.module.scss";
import { QuestionType } from "../../../../../service/service";
import { TopicType, OptionIsRight } from "../../../../../service/homework";

interface EditTianKongProps {
    topic: TopicType;
    blockOption?: EditBlockOption;
    onChangeNow?: (topic: TopicType) => void;
    onChange: (topic: TopicType) => void;
}

export default function EditTianKong({
    topic,
    blockOption,
    onChange,
    onChangeNow
}: EditTianKongProps) {
    const [innerTopic, setInnerTopic] = useState(topic);

    useEffect(() => {
        onChangeNow && onChangeNow(innerTopic);
    }, [innerTopic]);

    const handleOnChange = (value: string, index: number) => {
        const newTopic = { ...topic };
        newTopic.answers[index].content = value;
        newTopic.answers[index].isRight = OptionIsRight.Right;
        setInnerTopic(newTopic);
    };

    const handleDelete = (index: number) => {
        const newTopic = { ...topic };
        newTopic.answers.splice(index, 1);
        setInnerTopic(newTopic);
    };

    const handleAdd = () => {
        const newTopic = { ...topic };
        newTopic.answers.push({ content: "", isRight: OptionIsRight.Right });
        setInnerTopic(newTopic);
    };

    const onEditBlockChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        setInnerTopic({ ...newTopic, trunk: topic.trunk, score: topic.score });
        onChange && onChange(topic);
    };

    return (
        <EditBlock
            {...blockOption}
            type={QuestionType.TianKong}
            topic={innerTopic}
            onChange={onEditBlockChange}>
            <EditTianKongPure
                innerTopic={innerTopic}
                topic={topic}
                handleOnChange={handleOnChange}
                handleDelete={handleDelete}
                handleAdd={handleAdd}
            />
        </EditBlock>
    );
}

export interface EditTianKongPureProps {
    innerTopic: TopicType;
    topic: TopicType;
    handleOnChange: (value: string, index: number) => void;
    handleDelete: (index: number) => void;
    handleAdd: () => void;
}

export function EditTianKongPure({
    handleAdd,
    handleDelete,
    handleOnChange,
    innerTopic,
    topic
}: EditTianKongPureProps) {
    return (
        <React.Fragment>
            <Row>
                <Col span={3} className={style.label}>
                    填空：
                </Col>

                <Col span={20}>
                    {innerTopic.answers.map((answer, index) => {
                        return (
                            <Row
                                key={`${topic.tempTopicId}${index}`}
                                className={style.line}
                                gutter={[5, 10]}>
                                <Col span={1}>{index + 1}</Col>
                                <Col span={22}>
                                    <Input
                                        value={answer.content}
                                        onChange={e =>
                                            handleOnChange(
                                                e.target.value,
                                                index
                                            )
                                        }
                                        placeholder="请填写正确答案"
                                    />
                                </Col>
                                <Col span={1}>
                                    <Button
                                        onClick={() => handleDelete(index)}
                                        type="danger"
                                        icon="delete"
                                    />
                                </Col>
                            </Row>
                        );
                    })}
                    <Button onClick={handleAdd}>增加一个填空</Button>
                </Col>
            </Row>
        </React.Fragment>
    );
}
